
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'user-contact-list',
		prop1: '',
		prop2: '',
		prop3: [],

		userContactsArray: [],
		userContactsComp: '0',
		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2},

		setUserContacts(state, payload) { state.userContactsArray = payload.info; state.userContactsComp = payload.info1; },
		setUserContactsComp(state, payload) { state.userContactsComp = payload.info1; },

		setInvites(state, payload) { state.inviteArray = payload.info; state.inviteComp = payload.info1; },
		setInviteComp(state, payload) { state.inviteComp = payload.info1; },
		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2, prop3: payload.prop3 })  },
		getAllUserContacts(context, payload) {
			context.commit("setUserContactsComp", { info1: '0' }) 
			axios.get('/utility/user/contact/getallcontactsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserContacts", { info: b, info1: '1' }) 
	          	});
		},
		
		
		
	}

})